import { useMemoizedFn } from 'ahooks';
import { useQuery } from 'components/RouterQuery';
import { isAeProduct } from 'productLine';
import { stringify } from 'query-string';
import { generatePath } from 'react-router-dom';
import { authorize } from 'services/api';
import { getIsExistStore } from 'services/api/admin';
import { generateTypedPath } from 'views/AuthShopResult/AliExpress';
import { useTempPermissionUpdater } from './usePermission';
import { decode } from 'jsonwebtoken-esm';

export const aePreparePath = '/aePrepare';

function useGetLoginRedirectPath() {
  const updateTempPermission = useTempPermissionUpdater();
  const query = useQuery();
  const getLoginRedirectPath = useMemoizedFn((token: string) => {
    authorize(token);
    if (query?.action === 'ae_auth') {
      const path = generatePath('/:url?:queryString', {
        url: generateTypedPath('entered'),
        queryString: stringify(query),
      });
      return Promise.resolve(path);
    }

    if (isAeProduct || decode(token, { json: true })?.productLine === 'aeplugin') {
      return Promise.resolve(aePreparePath);
    }

    return getIsExistStore()
      .then((isExistStore) => {
        if (isExistStore) {
          updateTempPermission('SHOP_MANAGER', 'remove');
          return '/conversation';
        }

        updateTempPermission('SHOP_MANAGER', true);
        return '/management/shops';
      })
      .catch(() => {
        return '/conversation';
      });
  });

  return getLoginRedirectPath;
}

export default useGetLoginRedirectPath;
